export interface Language {
  code: string;
  name: string;
  flag: string;
}

export const AVAILABLE_LANGUAGES: Language[] = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "no", name: "Norsk", flag: "🇳🇴" },
  { code: "da", name: "Dansk", flag: "🇩🇰" },
  { code: "fi", name: "Suomi", flag: "🇫🇮" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
];

export const DEFAULT_LANGUAGES = ["en", "sv"];
export const PRIMARY_LANGUAGE = "en";

// Type for supported language codes
export type LanguageCode =
  | "en"
  | "sv"
  | "no"
  | "da"
  | "fi"
  | "de"
  | "fr"
  | "es";

// Helper to get language info by code
export function getLanguageInfo(code: string): Language | undefined {
  return AVAILABLE_LANGUAGES.find((lang) => lang.code === code);
}
